import { useDispatch, useSelector } from "react-redux";
import InfiniteScrollComponent from "../../../../../components/InfiniteScrollComponent/InfiniteScrollComponent";
import EmptyOrder from "../../EmptyOrder";
import InvoiceModal from "../../InvoiceModal";
import OrderItem from "../../OrderItem/OrderItem";
import TrackingModal from "../../TrackingModal";
import Action from "../redux/Action";
import ConfirmationModal from "../../../../../components/ConfirmationModal/ConfirmationModal";
import OrderConfModal from "../../../../../components/OrderConfModal/OrderConfModal";
import { useTranslation } from "react-multi-lang";
import OrderCancelModal from "../../../../../components/OrderCancelModal/OrderCancelModal";

const SelfPickupList = ({ search, sort, startDateFilter, endDateFilter }) => {

  const t = useTranslation();
  const dispatch = useDispatch();
  const list = useSelector((state) => state.reducer.list);
  const hasMoreItems = useSelector((state) => state.reducer.hasMoreItems);
  const loadingData = useSelector((state) => state.reducer.loadingData);
  const showInvoiceModal = useSelector((state) => state.reducer.showInvoiceModal);
  const invoiceDetail = useSelector((state) => state.reducer.invoiceDetail);
  const showTrackingModal = useSelector((state) => state.reducer.showTrackingModal);
  const trackingDetail = useSelector((state) => state.reducer.trackingDetail);
  const isEmptyList = useSelector((state) => state.reducer.isEmptyList);
  const page = useSelector((state) => state.reducer.page);
  const modalComplete = useSelector((state) => state.reducer.modalComplete);
  const modalCancel = useSelector((state) => state.reducer.modalCancel);
  const dataComplete = useSelector((state) => state.reducer.dataComplete);
  const dataCancel = useSelector((state) => state.reducer.dataCancel);
  
  return (
    <>
      {showInvoiceModal ? (
        <InvoiceModal
          onCancel={() => {
            Action.showInvoiceModal(dispatch, { showModal: false });
          }}
          title={invoiceDetail.invoice}
          invoiceDetail={invoiceDetail}
        />
      ) : (
        <></>
      )}
      {showTrackingModal ? (
        <TrackingModal
          onCancel={() => {
            Action.showTrackingModal(dispatch, { showModal: false });
          }}
          trackingDetail={trackingDetail}
        />
      ) : (
        <></>
      )}
      
      {modalComplete ? (
        <OrderConfModal
          onCancel={() => {
            Action.showModalComplete(dispatch, { showModal: false });
          }}
          title={t("orders.selfpickup_confirmation")}
          subtitle={t("orders.selfpickup_confirmation_desc")}
          onClick={async ({ remark }) => {
            Action.completeButton(dispatch, {id:dataComplete, remarks:remark})
          }}
        />
      ) : (
        <></>
      )}

      {modalCancel ? (
        <OrderCancelModal
        onCancel={() => {
          Action.showModalCancel(dispatch, { showModal: false });
        }}
        title={t("orders.selfpickup_cancel_confirmation")}
        subtitle={t("orders.selfpickup_cancel_confirmation_desc")}
        onClick={async ({ reason }) => {
          Action.CancelButton(dispatch, {id:dataCancel, reason: reason})
        }}
      />
      ) : (
        <></>
      )}
      

      <div className="max-h-[26.5rem] overflow-y-auto">
        {!isEmptyList ? (
          <InfiniteScrollComponent
            loadMore={async () => {
              if (!loadingData) {
                Action.getList(dispatch, {
                  currentList: list,
                  search: search,
                  sort: sort,
                  startDateFilter: startDateFilter,
                  endDateFilter: endDateFilter,
                  page: page,
                });
              }
            }}
            hasMore={hasMoreItems}
            useWindow={false}
            threshold={100}
            loader={<div key={0} height={"464px"} />}
            children={
              <ul>
                {list.map((item, index) => (
                  <li key={index}>
                    <OrderItem
                      item={item}
                      showInvoice={() => {
                        Action.showInvoiceModal(dispatch, {
                          showModal: true,
                          invoiceDetail: item,
                        });
                      }}
                      showTracking={() => {
                        Action.showTrackingModal(dispatch, {
                          showModal: true,
                          id: item.id,
                        });
                      }}
                      setPickUp={() => {
                        Action.setPickUp(dispatch, {
                          id: item.id,
                        });
                      }}
                      setComplete={() => {
                        Action.showModalComplete(dispatch, {showModal: true, id: item.id});
                      }}
                      setCancel={() => {
                        Action.showModalCancel(dispatch, {showModal: true, id: item.id});
                      }}
                    />
                  </li>
                ))}

              



              </ul>
            }
          />
        ) : (
          <EmptyOrder />
        )}
      </div>
    </>
  );
};

export default SelfPickupList;
